import { useEffect, useState } from "react";
import { Navbar } from "@/components/Navbar";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Mail } from "lucide-react";

export default function Settings() {
  const { user, updateUser } = useAuth();
  const [optIn, setOptIn] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then((r) => { setOptIn(!!r.data.newsletter_opt_in); updateUser({ newsletter_opt_in: r.data.newsletter_opt_in }); });
    // eslint-disable-next-line
  }, []);

  const toggle = async (checked) => {
    setOptIn(checked); setBusy(true);
    try {
      const { data } = await api.post("/auth/profile", { newsletter_opt_in: checked });
      if (checked) { updateUser({ newsletter_opt_in: true }); toast.success("Almost there — check your email to confirm your subscription"); }
      else { updateUser({ newsletter_opt_in: false }); toast.success("Unsubscribed from bulk emails"); }
    } catch { toast.error("Could not update preference"); setOptIn(!checked); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 lg:px-10 py-12">
        <span className="text-xs uppercase tracking-[0.3em] text-emerald-700">Profile settings</span>
        <h1 className="mt-2 font-serif text-4xl text-emerald-950">Your preferences</h1>
        <p className="mt-2 text-stone-500 text-sm">Signed in as {user?.email}</p>

        <div className="mt-8 rounded-2xl border border-black/5 bg-white p-6 shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
          <div className="flex items-center gap-2 text-emerald-700"><Mail className="w-4 h-4" /><span className="text-xs uppercase tracking-[0.15em]">Email preferences</span></div>
          <label data-testid="settings-newsletter" className="mt-4 flex items-start gap-3 cursor-pointer select-none">
            <input type="checkbox" checked={optIn} disabled={busy} onChange={(e) => toggle(e.target.checked)} className="mt-0.5 w-5 h-5 accent-emerald-700" />
            <span>
              <span className="block text-sm font-medium text-emerald-950">Newsletter &amp; announcements</span>
              <span className="block text-sm text-stone-500">Receive PlantFlow seasonal tips, product updates, and landcare stories. Uncheck to stop bulk emails.</span>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
}
